import { Pipe, PipeTransform } from '@angular/core';
import { ActivityDto } from '@bo-client/shared/models/activityDto';
import { MetaService, StatusType } from '@bo-client/core/api/meta-service';
import { TenantlessEmailPipe } from '@bo-client/shared/pipes/tenantless-email.pipe';

@Pipe({
  name: 'activityName'
})
export class ActivityTypePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    switch (value) {
      case 'CONVERSATION':
        return 'Chat';
      case 'PHONE_CALL':
        return 'Telefonanruf';
      case 'EMAIL_ACTIVITY':
        return 'EMail gesendet';
    }
    return value;
  }
}

@Pipe({
  name: 'lastActivityState'
})
export class LastActivityStatePipe implements PipeTransform {
  transform(listAct: any[], args?: any): any {
    if (listAct == null) {
      return '';
    }
    const numItems = listAct.length;
    if (numItems == 0) {
      return '';
    }
    if (listAct[numItems - 1].state == null) {
      return '';
    }
    switch (listAct[numItems - 1].state) {
      case 'OPEN':
        return 'Geöffnet';
      case 'IN_PROGRESS':
        return 'In Bearbeitung';
      case 'DONE':
        return 'Erledigt';
    }
    return '';
  }
}

@Pipe({
  name: 'activityIcon'
})
export class ActivityIconPipe implements PipeTransform {
  transform(value: any, hasStatusTo?: any, hasStatusFrom?: any): any {
    switch (value) {
      case 'CONVERSATION':
        return 'forum';
      case 'PHONE_CALL':
        return 'android_dialer';
      case 'EMAIL_ACTIVITY':
        return 'mail';
      case 'AUDIT_ACTIVITY':
        if (hasStatusTo) {
          if (hasStatusFrom) {
            return 'change_circle';
          } else {
            return 'arrow_circle_right';
          }
        } else {
          return 'settings';
        }
    }
    return 'pending';
  }
}

@Pipe({
  name: 'activityDescription'
})
export class ActivityDescriptionPipe implements PipeTransform {
  transform(value: any, activity?: ActivityDto): any {
    switch (value) {
      case 'CONVERSATION':
        return 'Chat';
      case 'PHONE_CALL':
        return 'Telefon';
      case 'EMAIL_ACTIVITY':
        return 'E-Mail';
      case 'AUDIT_ACTIVITY':
        if (activity.stateTo) {
          if (activity.stateFrom) {
            return 'Statuswechsel';
          } else {
            return 'durchgeführte Aktion';
          }
        } else {
          return 'Audit';
        }
    }
    return '----';
  }
}

@Pipe({
  name: 'activityInformation'
})
export class ActivityInformationPipe implements PipeTransform {
  constructor(private metaService: MetaService, private tenantlessEmailPipe: TenantlessEmailPipe) {}

  transform(activity?: ActivityDto): any {
    const combinedStatusList = [
      ...this.metaService.installerPassStatus,
      ...this.metaService.commissioningRequestStatus,
      ...this.metaService.getGridRegistrationStatus(),
      ...this.metaService.getFeederContractStatus()
    ];

    switch (activity.type) {
      case 'EMAIL_ACTIVITY':
        return activity.subject;
      case 'AUDIT_ACTIVITY':
        const stateToDisplayName = this.statusDisplayName(combinedStatusList, activity.stateTo);
        const stateFromDisplayName = this.statusDisplayName(combinedStatusList, activity.stateFrom);

        return (
          stateFromDisplayName +
          ' -> ' +
          stateToDisplayName +
          ' (' +
          (activity.createdBy == 'anonymousUser'
            ? 'externer Benutzer'
            : this.tenantlessEmailPipe.transform(activity.createdBy)) +
          ')'
        );
    }
    return '----';
  }

  /**
   * Anzeigename eines Status aus den bekannten Statuslisten. Unbekannte Status (z. B. `DELETED` aus
   * dem Lösch-Audit oder Status von Bestellung und Anschlussänderung) erscheinen im Rohwert, ein
   * fehlender Status als `—`.
   */
  private statusDisplayName(statusList: StatusType[], state?: string): string {
    if (!state) {
      return '—';
    }
    return statusList.find((x) => x.value.toLowerCase() == state.toLowerCase())?.displayName ?? state;
  }
}

@Pipe({
  name: 'userActivity'
})
export class UserActivityPipe implements PipeTransform {
  transform(userName?: string): any {
    if (userName == 'anonymousUser') {
      return 'externe Benutzer';
    }
    return userName;
  }
}

@Pipe({
  name: 'statusEntityAuditActivity'
})
export class StatusEntityAuditActivityPipe implements PipeTransform {
  constructor(private metaService: MetaService) {}

  transform(statusName?: any): any {
    if (statusName == null) {
      return '---';
    }
    const statusList: any[] = [
      ...this.metaService.commissioningRequestStatus,
      ...this.metaService.getGridRegistrationStatus(),
      ...this.metaService.getFeederContractStatus(),
      ...this.metaService.installerPassStatus
    ];
    const currentStatus: any = statusList.find((x) => x.value.toLowerCase() == statusName.toLowerCase());
    if (currentStatus && currentStatus.displayName) {
      return currentStatus.displayName;
    }
    return statusName;
  }
}
